export const EmailIcon = () => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		width="25"
		height="24"
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="tdesign:mail">
			<path
				id="Vector"
				d="M1.33398 3H23.334V21H1.33398V3ZM3.33398 5V6.83L12.334 11.38L21.334 6.83V5H3.33398ZM21.334 9.07L12.334 13.62L3.33398 9.07V19H21.334V9.07Z"
				fill="#998C9C"
			/>
		</g>
	</svg>
);
